import { h } from 'preact'
import Portal from 'preact-portal'
import {typeMap} from './editor'

interface Props {
  type: keyof typeof typeMap
  placeHolder?: HTMLElement
}

export default function EmptyPlaceholder ({type, placeHolder}: Props) {
  return placeHolder
    ? <Portal into={placeHolder}>
    <div class="sitewidth">
      <div class="homepage-widget--emtpy">
        {typeMap[type]}
      </div>
    </div>
  </Portal>
  : null
}
